import { CommunityGroup } from "@/api";

export enum Reactions {
  like = "like",
}

export type PostItem = {
  id: string;
  postCreator: Amity.User;
  date: Date;
  textContent?: string;
  attachments?: Amity.File<"image" | "video">[];
  likes: number;
  comments: number;
  haveLiked: boolean;
  isOwner: boolean;
  subscribeTopic: string;
  pinned?: boolean;
  parentFeedId: string;
  flagCount: number;
};

export type MapAmityPostOptions = {
  post: Amity.Post;
  currentUserId?: string;
};

export type CommentItem = {
  id: string;
  commentCreator: Amity.User;
  date: Date;
  textContent: string;
  attachments?: Amity.File<"image">[];
  likes: number;
  repliesCount: number;
  haveLiked: boolean;
  isOwner: boolean;
  subscribeTopic: string;
  children: string[];
  referenceId: string;
  flagCount: number;
};

export type MapAmityCommentsOptions = {
  comments: Amity.InternalComment[];
  currentUserId?: string;
};

export type MapAmityCommentOptions = {
  comment: Amity.InternalComment;
  currentUserId?: string;
};

export type CommunityGroupWithDetails = CommunityGroup & {
  membersCount: number;
  isJoined: boolean;
};
